import { useCallback, useRef } from 'react';
import type { SurveySession } from '../fetchSurvey/types/survey';
import { markResponseInstanceAsStarted } from './utils/markResponseInstanceAsStarted';

/**
 * Hook that exposes a one-shot mark-as-started call, idempotent per hook instance.
 */
export function useMarkAsStarted(session?: SurveySession | null) {
  const hasMarkedRef = useRef(false);
  const instanceCreatedTimeRef = useRef<number | undefined>(undefined);

  const markOnce = useCallback(() => {
    const instanceId = session?.instanceId?.trim();
    if (!instanceId || hasMarkedRef.current) return;

    hasMarkedRef.current = true;
    instanceCreatedTimeRef.current = Date.now();
    void markResponseInstanceAsStarted(instanceId);
  }, [session?.instanceId]);

  const getInstanceCreatedTime = useCallback(() => instanceCreatedTimeRef.current, []);

  return { markOnce, getInstanceCreatedTime };
}
